<div class="d-flex align-items-center mb-3 gap-3">
  <div class="d-flex align-items-center gap-2">
    <h6 class="mb-0 page-title" i18n>Reviews</h6>
    <app-page-help articleId="qqWCoKgyAYQwGs5j6ozTqa" videoId="-"></app-page-help>
    <ul class="internal-module-switcher ml-3">
      <li
        class="module-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        matTooltip="Dashboard"
        i18n-matTooltip
      >
        <a routerLink="/reviews">
          <i class="cs-icon cs-icon-dashboard2 text-xl"></i>
        </a>
      </li>
      <li class="module-item" routerLinkActive="active" matTooltip="Reviews" i18n-matTooltip>
        <a routerLink="/reviews/list">
          <i class="cs-icon cs-icon-chat-star2 text-xl"></i>
        </a>
      </li>
      <li class="module-item" routerLinkActive="active" matTooltip="Bookings" i18n-matTooltip>
        <a routerLink="/reviews/bookings">
          <i class="cs-icon cs-icon-calendar-alt text-xl"></i>
        </a>
      </li>
    </ul>
  </div>
  <div class="flex-fill"></div>
  <ng-template [ngTemplateOutlet]="automationBtn"></ng-template>

  <app-reviews-filters
    [source]="source"
    (filtersChange)="onFiltersChange($event)"
    (refresh)="onRefresh()"
    #filtersComponent
  ></app-reviews-filters>
</div>

<div class="row">
  <div class="col-lg-8 d-flex flex-column gap-3">
    <app-reviews-stats (sourceChange)="source = $event" [filters]="filters" [data]="data"></app-reviews-stats>
    <app-review-montly-avg-rating [isLoading]="isLoading" [data]="data"></app-review-montly-avg-rating>
    <app-rental-avg-rating [isLoading]="isLoading" [data]="data"></app-rental-avg-rating>
  </div>
  <div class="col-lg-4 pl-lg-0">
    <div class="container-box h-100">
      <ul class="nav top-navbar border-bottom pt-2">
        <li [class.active]="reviewTab === 'recent'">
          <a href="javascript:;" (click)="reviewTab = 'recent'"> <ng-container i18n>Latest Reviews</ng-container> </a>
        </li>
        <li [class.active]="reviewTab === 'insights'">
          <a href="javascript:;" (click)="reviewTab = 'insights'">
            <span
              matTooltip="Get AI-powered tips to improve your property and increase revenue based on the guest review."
              i18n-matTooltip
              i18n
              >AI Review insights</span
            >
            <a
              openArticleId="vRftdGeWVMM3t19BEZkmrT"
              class="text-dark"
              matTooltip="Click here to see the associated help article."
              i18n-matTooltip
            >
              <i class="cs-icon cs-icon-question-circle"></i>
            </a>
          </a>
        </li>
      </ul>
      <app-recent-reviews *ngIf="reviewTab === 'recent'" [filters]="filters" #reviews></app-recent-reviews>
      <ng-container *ngIf="reviewTab === 'insights'">
        <app-rental-review-insights
          *ngIf="(isAISubscribed$ | async)?.isValid"
          [data]="data?.rentalAverageOverallRating"
        ></app-rental-review-insights>
        <app-unlock-rental-review-insights
          *ngIf="!(isAISubscribed$ | async)?.isValid"
        ></app-unlock-rental-review-insights>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #automationBtn>
  <button
    (click)="onAddAutomation()"
    [disabled]="1 | isReadonlyRole"
    class="btn btn-secondary-info"
    i18n-matTooltip
    matTooltip="Define rules to create your reviews automatically"
  >
    <span class="cs-icon cs-icon-automations"></span>
    <ng-container i18n>Automation</ng-container>
  </button>
</ng-template>

<ng-template #addBtn>
  <button (click)="onAddChannel()" [disabled]="1 | isReadonlyRole" class="btn btn-secondary-info">
    <span class="cs-icon cs-icon-plug"></span>
    <ng-container i18n>Connect Channel</ng-container>
  </button>
</ng-template>

<app-setup-layer [loading]="reviews?.isLoading" *ngIf="!(isAnyChannelConnected$ | async)">
  <img src="/assets/images/empty_images/reviews.png" alt="" style="width: 360px" />
  <h6 i18n>Optimize Your Listing with Insightful Guest Reviews!</h6>
  <ol class="w-100" style="max-width: 600px">
    <li>
      <div>
        <b i18n>Overview:</b><ng-container>&nbsp;</ng-container>
        <ng-container i18n>Access a comprehensive view of Airbnb reviews received for your listings.</ng-container>
      </div>
    </li>
    <li>
      <div>
        <b i18n>Review Count:</b><ng-container>&nbsp;</ng-container>
        <ng-container i18n
          >At the top, see the total number of guest reviews. Filter reviews by Airbnb to streamline your
          focus.</ng-container
        >
      </div>
    </li>
    <li>
      <div>
        <b i18n>Recent Reviews:</b><ng-container>&nbsp;</ng-container
        ><ng-container i18n
          >Browse the latest guest reviews and ratings, displayed first. View and manage your responses directly from
          this section.</ng-container
        >
      </div>
    </li>
    <li>
      <div>
        <b i18n>Review Filters:</b><ng-container>&nbsp;</ng-container
        ><ng-container i18n
          >Easily filter reviews by specific listings to better manage your responses and insights.</ng-container
        >
      </div>
    </li>
    <li>
      <div>
        <b i18n>Unreplied Reviews:</b><ng-container>&nbsp;</ng-container
        ><ng-container i18n
          >Quickly spot and reply to reviews awaiting your response right from the dashboard.</ng-container
        >
      </div>
    </li>
    <li>
      <div>
        <b i18n>Ratings Distribution:</b><ng-container>&nbsp;</ng-container
        ><ng-container i18n
          >Explore the median ratings across categories like Accuracy, Checkin, Cleanliness, and more, visualized with a
          pie chart for overall ratings.</ng-container
        >
      </div>
    </li>
    <li>
      <div>
        <b i18n>Monthly Breakdown:</b><ng-container>&nbsp;</ng-container>
        <ng-container i18n
          >Review the monthly review trends with a bar chart, highlighting the range from lowest to highest
          ratings.</ng-container
        >
      </div>
    </li>
  </ol>
  <div class="d-flex align-items-center justify-content-center gap-3">
    <button class="btn btn-secondary-primary" openArticleId="reviews" [category]="true" i18n>Learn More</button>
    <ng-template [ngTemplateOutlet]="automationBtn"></ng-template>
  </div>
</app-setup-layer>
